var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverviewInactive = function SvgOverviewInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M3 17.75A3.25 3.25 0 0 0 6.25 21H9V3H6.25A3.25 3.25 0 0 0 3 6.25v11.5ZM10.5 3h7.25A3.25 3.25 0 0 1 21 6.25V8.5H10.5V3ZM21 10v7.75A3.25 3.25 0 0 1 17.75 21H10.5V10H21Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "overview-inactive_svg__a",
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M3 17.75A3.25 3.25 0 0 0 6.25 21H9V3H6.25A3.25 3.25 0 0 0 3 6.25v11.5ZM10.5 3h7.25A3.25 3.25 0 0 1 21 6.25V8.5H10.5V3ZM21 10v7.75A3.25 3.25 0 0 1 17.75 21H10.5V10H21Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#overview-inactive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M10.5 10v11H21V10H10.5Z"
  }))));
};
export default SvgOverviewInactive;